import { computed, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeDetectionService {
  isMobile = computed(() => globalThis.navigator.userAgent.toLowerCase().includes('mobile'));
  isDesktop = computed(() => globalThis.navigator.userAgent.toLowerCase().includes('desktop'));
}
